var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnsealing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746514380901,
    className: "icon",
    viewBox: "0 0 1055 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 46921,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.453125,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.64238 0C115.122314 0 0 115.122314 0 256.64238l0 180.435889 104.361166 0 0-180.435889c0-83.95891 68.322304-152.281214 152.281214-152.281214s152.281214 68.300342 152.281214 152.281214l0 180.435889 104.383128 0 0-180.435889C513.306722 115.122314 398.162447 0 256.64238 0z",
    fill: "#ffffff",
    "p-id": 46922
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M971.599824 467.494981 373.631423 467.494981c-45.438395 0-82.289834 36.829477-82.289834 82.267872l0 391.947335c0 45.460357 36.829477 82.289834 82.289834 82.289834l597.9684 0c45.416434 0 82.245911-36.829477 82.245911-82.289834L1053.845734 549.740892C1053.845734 504.324458 1017.038219 467.494981 971.599824 467.494981zM838.425136 781.830287l-81.52118 0c-14.011453 32.700711-46.448625 55.606581-84.288333 55.606581s-70.27688-22.90587-84.310294-55.606581l-81.52118 0 0-72.187532 81.52118 0c14.033414-32.678749 46.470587-55.58462 84.310294-55.58462s70.27688 22.90587 84.288333 55.58462l81.52118 0L838.425136 781.830287z",
    fill: "#ffffff",
    "p-id": 46923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsealing);
export default __webpack_public_path__ + "static/media/unsealing.aafe096f2369a9c9d86f86b68017fed1.svg";
export { ForwardRef as ReactComponent };